export function getUrlVars(search?: string) {
    search = search ? search : window.location.search
    let vars: any = [],
        hash;
    let hashes = search.substr(1).split('&');
    for (let i = 0; i < hashes.length; i++) {

        hash = hashes[i].split('=');

        vars.push(decodeURI(hash[0]));
        vars[decodeURI(hash[0])] = decodeURI(hash[1]);
    }

    return vars;
}


export function dispatchCustomEvent(eventName: string, data: any, bubbles = true, cancelable = true, element: HTMLElement | null = null) {
    const customEvent = new CustomEvent(eventName, {
        detail: data,
        bubbles: bubbles,
        cancelable: cancelable
    });

    if (element === null) {
        document.dispatchEvent(customEvent);
    } else {
        element.dispatchEvent(customEvent);
    }
}

export function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

export function deepMerge(target, source) {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else output[key] = deepMerge(target[key], source[key]);
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
}